/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAIToolsPathParams = NonNullable<operations['listAITools']['parameters']['path']>;

export type ListAIToolsQueryParams = NonNullable<operations['listAITools']['parameters']['query']>;

export interface Input extends ListAIToolsPathParams {
  apiVersion?: string;
  query?: ListAIToolsQueryParams;
}

export async function listAITools(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-tools', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
